var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_916_4926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31039 7.80051C6.98661 9.0739 7.80815 9.97759 11.3408 9.97759H14.7208V16.5851C14.7208 23.4215 15.3194 25 17.8779 25C19.0045 25 19.1512 24.777 18.4764 23.574C18.1008 22.7466 17.7253 19.7422 17.7253 16.814C17.7253 12.6065 17.5023 11.4035 16.446 10.805C15.3956 10.2006 15.9238 10.0539 18.9282 9.97759C22.3846 9.97759 24.4854 9.0739 24.4854 7.57166C24.4854 6.67383 10.8126 6.89682 9.31039 7.80051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_916_4926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTao);
export default __webpack_public_path__ + "static/media/TAO.16faa9e595b1830e1dc1f25dd153eabd.svg";
export { ForwardRef as ReactComponent };